import React from 'react';
import PropTypes from 'prop-types';
import Input from '@mui/material/Input';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import numberToWords from 'number-to-words';
import { styled } from 'styled-components';

const ShowAmountText = styled.p`
  font-family: 'Noto Sans';
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  line-height: 125%;
  text-align: right;
  color: #1eaece;
`;

const InputField = ({ showIcon, placeholder, showAmount, value, onChange }) => {
  const convertToWords = (value) => {
    const numericValue = parseInt(value, 10);
    if (!isNaN(numericValue)) {
      return numberToWords.toWords(numericValue) + ' rupees only';
    }
    return 'No Amount';
  };

  const convertedValue = showAmount ? convertToWords(value) : '';
  const handleInputChange = (event) => {
    const inputValue = event.target.value.slice(0, 10);
    onChange(inputValue);
  };

  const handleKeyDown = (e) => {
    if (['ArrowUp', 'ArrowDown', '-', '.', 'e', 'E'].includes(e.key)) {
      e.preventDefault();
    }
  };
  return (
    <div style={{ width: '100%' }}>
      <FormControl
        variant="standard"
        sx={{
          m: 1,
          minWidth: 420,
          width: '100%',
          marginRight: '0',
          marginLeft: '0',
          '@media (max-width: 767px)': {
            minWidth: 'unset',
            width: '100%',
            marginRight: '0',
            marginLeft: '0',
          },
          '& input': {
            '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button':
              {
                '-webkit-appearance': 'none',
                margin: 0,
              },
          },
        }}
      >
        <Input
          id="input-with-icon-adornment"
          type="number"
          startAdornment={
            showIcon && (
              <InputAdornment position="start">
                <CurrencyRupeeIcon
                  sx={{ color: '#000000', fontSize: 'medium' }}
                />
              </InputAdornment>
            )
          }
          placeholder={placeholder || ''}
          value={value}
          onChange={handleInputChange}
          onWheel={(e) => e.target.blur()}
          onKeyDown={handleKeyDown}
          inputProps={{ maxLength: '10' }}
        />
      </FormControl>
      {showAmount && convertedValue && (
        <ShowAmountText>{convertedValue}</ShowAmountText>
      )}
    </div>
  );
};

InputField.propTypes = {
  showIcon: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired,
  showAmount: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default InputField;
